import { configQuery, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { getConfigureOtpForm } from './configure-otp.config.js';

var KeycloakConfigureOtp = /** @class */ (function (_super) {
    __extends(KeycloakConfigureOtp, _super);
    function KeycloakConfigureOtp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formConfig = null;
        _this.shouldSkip = false;
        _this.hasSubmitted = false;
        return _this;
    }
    KeycloakConfigureOtp.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var skipConfig, isSkipEnrolmentPageEnabled, _a, phone_prefix, phone_number, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, configQuery('keycloak.skipEnrolmentPage')];
                    case 1:
                        skipConfig = _c.sent();
                        isSkipEnrolmentPageEnabled = skipConfig === true;
                        if (isSkipEnrolmentPageEnabled) {
                            _a = this.kcContext, phone_prefix = _a.phone_prefix, phone_number = _a.phone_number;
                            if (phone_prefix && phone_number) {
                                this.shouldSkip = true;
                                this.hasSubmitted = true;
                                this.$emit('auto-submitting', true);
                                this.immediateSubmit(phone_prefix, phone_number);
                                return [2 /*return*/];
                            }
                        }
                        _b = this;
                        return [4 /*yield*/, getConfigureOtpForm(this.getDefaultPhone())];
                    case 2:
                        _b.formConfig = _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    KeycloakConfigureOtp.prototype.immediateSubmit = function (phonePrefix, phoneNumber) {
        var form = document.createElement('form');
        form.action = this.kcContext.url.loginAction;
        form.method = 'post';
        form.style.display = 'none';
        var inputs = [
            { name: 'phone_prefix', value: phonePrefix },
            { name: 'phone_number', value: phoneNumber },
        ];
        inputs.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            var input = document.createElement('input');
            input.name = name;
            input.value = value;
            form.appendChild(input);
        });
        document.body.appendChild(form);
        form.submit();
    };
    KeycloakConfigureOtp.prototype.getDefaultPhone = function () {
        var phone = '';
        var _a = this.kcContext, phone_prefix = _a.phone_prefix, phone_number = _a.phone_number;
        if (phone_prefix) {
            phone += phone_prefix;
        }
        if (phone_number) {
            phone += ' ' + phone_number;
        }
        return phone;
    };
    Object.defineProperty(KeycloakConfigureOtp.prototype, "configureOtpAction", {
        get: function () {
            return this.kcContext.url.loginAction;
        },
        enumerable: false,
        configurable: true
    });
    KeycloakConfigureOtp.prototype.submit = function (value) {
        if (this.hasSubmitted) {
            return;
        }
        var form = this.$refs.form;
        this.getInput(form, 'phone_prefix').value = value.mobilePrefix;
        this.getInput(form, 'phone_number').value = value.mobileNumber;
        form.submit();
    };
    KeycloakConfigureOtp.prototype.getInput = function (form, name) {
        return form.elements.namedItem(name);
    };
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], KeycloakConfigureOtp.prototype, "kcContext", void 0);
    KeycloakConfigureOtp = __decorate([
        Component({
            name: 'corex-keycloak-configure-otp',
        })
    ], KeycloakConfigureOtp);
    return KeycloakConfigureOtp;
}(Mixins(MagicConfigMixin)));

export default KeycloakConfigureOtp;
